/*
 * @Description: 产品检验标准管理
 * @Author: saibo.han
 * @Date: 2024.04.16
 * @LastEditors: saibo.han
 * @LastEditTime: 2024.04.16
 */
<template>
  <div class="price-manager" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline :model="form" ref="form">
      <el-form-item label="产品检验标准" prop="itemStandard">
        <el-input v-model="form.itemStandard"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="obj">
        <search-select
          v-model="form.obj"
          type="product"
          clearable
          placeholder="请输入关键词"></search-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      tooltip-effect="light"
      style="width: 100%"
    >
    <el-table-column
        prop="itemCode"
        label="商品编码"
        :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column
        prop="itemName"
        label="商品名称"
        :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column
        prop="itemClassify"
        label="物料描述"
        :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column
        prop="itemStandard"
        label="产品检验标准"
        :show-overflow-tooltip="true">
    </el-table-column>
   </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="pageNo"
      background>
    </el-pagination>
  </div>
</template>
<script>

import { mapActions } from 'vuex'
import SearchSelect from '@/components/searchSelect/index'
export default {
  name: 'qualityManager',
  components: { SearchSelect },
  data () {
    return {
      form: {
        itemStandard: '',
        obj: {}

      },
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getProjectInspectionManagement']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSearch () {
      const params = {
        itemCode: this.form.obj ? this.form.obj.code : '',
        itemName: this.form.obj ? this.form.obj.name : '',
        itemStandard: this.form.itemStandard,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.getProjectInspectionManagement(params).then(res => {
        this.list = res.list
        this.total = res.total
        this.pageNo = res.pageNum
        this.pageSize = res.pageSize
      })
    },
    reset () {
      this.$refs['form'].resetFields()
      this.pageNo = 1
      this.pageSize = 10
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.handleSearch()
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.handleSearch()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
